import { usePunditUserContext } from "@circle-react/contexts";

export const useIsTextAlignmentEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.text_editor_text_alignment_enabled);
};
